import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "main-body",
    "data-cy": "order-wrapper"
};
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "mt-1 float-right body2-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DrawerToggleButton = _resolveComponent("DrawerToggleButton");
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    const _component_OrderStatus = _resolveComponent("OrderStatus");
    const _component_OrderSearch = _resolveComponent("OrderSearch");
    const _component_OrderList = _resolveComponent("OrderList");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" 배달 목록 접기 버튼 "),
        _createVNode(_component_DrawerToggleButton, {
            "test-id": "order-toggle-btn",
            "is-drawer-open": _ctx.isDrawerOpen,
            "on-click": _ctx.handleClickDrawerBtn
        }, null, 8 /* PROPS */, ["is-drawer-open", "on-click"]),
        _createElementVNode("div", _hoisted_1, [
            _createCommentVNode(" header "),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_BarogoTooltip, null, {
                    activatorSlot: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}request_order_list`)), 1 /* TEXT */)
                    ]),
                    tooltipMessage: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}order_date_range`)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.lc + 'share_order_state', [_ctx.isHideShareOrderOnOff])), 1 /* TEXT */)
            ]),
            _createCommentVNode(" 주문 현황 "),
            _createVNode(_component_OrderStatus),
            _createCommentVNode(" 검색 "),
            _createVNode(_component_OrderSearch, {
                placeholder: _ctx.$t(_ctx.lc + 'order_search_placeholder'),
                "on-search": _ctx.onSearch
            }, null, 8 /* PROPS */, ["placeholder", "on-search"]),
            _createCommentVNode(" 주문 목록 "),
            _createVNode(_component_OrderList, { class: "root-order-list" })
        ])
    ]));
}
